module.exports = __webpack_public_path__ + "img/inspiration-2@2x.ff990ca.jpg";